import React from 'react';
import { Box, Typography } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import FlightLandIcon from '@mui/icons-material/FlightLand';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles(() => ({
    capitalize: {
        textTransform: 'capitalize'
    }
}));
const Title = (props) => {
    const classes = useStyles();
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                p: props.px ? (0.5, 1) : props.px,
            }}>
            {props.addicon ? (
                props.addicon == 'takeoff' ? (
                    <FlightTakeoffIcon color="primary" />
                ) : (
                    <FlightLandIcon color="primary" />
                )
            ) : null}
            <Typography
                variant="h4"
                flexGrow={1}
                fontSize={16}
                fontWeight={600}
                color='primary'
                noWrap
                component="div"
                className={classes.capitalize}
                sx={{}}
                {...props}>
                {props.title}
            </Typography>
        </Box>
    );
};
export default Title;
